<template>
  <div class="recruitment">
    <div class="topSearch" @click="search = true">
      <div class="search">
        <!-- <van-icon url="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/d3d1.png" /> -->
        <img src="../../assets/search.png" alt="" style="width: 20px" />
        <span style="margin-left: 15px">请选择搜索内容</span>
      </div>
    </div>
    <div>
      <van-popup v-model="search" position="top" :style="{ height: '42%' }">
        <div style="margin-top: 20px">
          <van-field
            v-model="listdata.title"
            label="职位名称"
            placeholder="请输入职位名称"
          />
          <van-field
            v-model="listdata.eName"
            label="企业名称"
            placeholder="请输入企业名称"
          />
          <!-- <van-field
          v-model="listdata.abiName"
          label="职业类型"
          placeholder="请选择职业类型"
          @click="abiName = true"
          readonly="readonly"
        />
        <van-popup v-model="abiName" position="bottom" get-container="body">
          <van-cascader
            title="请选择职业类型"
            :options="zhiye"
            @close="abiName = false"
            :field-names="{
              text: 'Name',
              value: 'Coding',
              children: 'Children',
            }"
            @finish="onabiName"
          />
        </van-popup> -->
          <van-field
            v-model="listdata.workAddr"
            label="工作地址"
            placeholder="请选择工作地址"
          />
          <van-button
            round
            type="info"
            style="width: 90%; margin: 25px 5% 10px"
            @click="toliost()"
            >搜 索</van-button
          >
          <van-button
            round
            type="primary"
            style="width: 90%; margin: 5px 5%"
            @click="serachReset"
            >重 置</van-button
          >
        </div>
      </van-popup>
    </div>
    <div>
      <div>
        <!-- 轮播图 -->
        <div>
          <img
            src="../../assets/招聘首页背景.png"
            alt=""
            style="width: 100%; height: 330px"
          />
          <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item>
              <img src="../../assets/招聘首页背景.png" alt="" style="width: 100%" />
            </van-swipe-item>
            <van-swipe-item>
              <img src="../../assets/lunbob.jpg" alt="" style="width: 100%" />
            </van-swipe-item>
          </van-swipe> -->
        </div>
        <!-- 登录入口 -->
        <div
          style="width: 95%; margin: 8px 2.5%; position: absolute; top: 195px"
        >
          <span class="loginbox">
            <div style="margin-right: 4%">
              <!-- style="width: 25%; display: block; margin: 13px" -->
              <div class="item" @click="firmlogin">
                <img
                  src="../../assets/企业.png"
                  alt=""
                  style="width: 40px; height: 40px"
                />
                <span class="loginbox_A">
                  <span>企业登录</span>
                </span>
              </div>
              <div class="item" @click="recruitment">
                <img
                  src="../../assets/求职者.png"
                  alt=""
                  style="width: 40px; height: 40px"
                />
                <span class="loginbox_A">
                  <span>求职者登录</span>
                </span>
              </div>
              <div class="item" @click="staffLogin">
                <img
                  src="../../assets/员工登录.png"
                  alt=""
                  style="width: 40px; height: 40px"
                />
                <span class="loginbox_A">
                  <span>员工登录</span>
                </span>
              </div>
            </div>
          </span>
        </div>
        <div class="topBox">
          <div
            :class="{ '2': selected == '2', topBoxLeft: selected != '2' }"
            @click="tapClick(1)"
            style="text-align: center; width: 100px"
          >
            <span>热门行业</span>
          </div>
          <div
            :class="{ '2': selected == '1', topBoxRight: selected != '1' }"
            @click="tapClick(2)"
            style="text-align: center; width: 100px"
          >
            <span>热门公司</span>
          </div>
        </div>
        <!-- 广播通告 -->
        <!-- <div class="box">
          <van-notice-bar left-icon="volume-o" text="【友情提示】 智慧就业已正式发布使用!" />
        </div> -->
        <!-- 热门行业 -->
        <div class="box" style="margin-top: 10px" v-if="selected == 1">
          <div
            style="
              padding: 10px 0px;
              position: relative;
              font-size: 18px;
              width: 100%;
            "
          >
            <!-- <span class="dot"></span> -->
            <span style="padding-left: 20px; font-weight: bold">热门行业</span>
            <span class="title_right" @click="toliost(null)"
              >更多

              <van-icon name="arrow" class="icon_right" />
            </span>
          </div>
          <van-swipe
            class="my-swipe"
            :autoplay="300000"
            indicator-color="white"
            :loop="false"
          >
            <van-swipe-item class="gridlist">
              <van-grid style="padding-bottom: 20px" :border="false">
                <van-grid-item @click="toliost(1)">
                  <img src="../../assets/icon_internet@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 12px">互联网</div>
                </van-grid-item>
                <van-grid-item @click="toliost(2)">
                  <img src="../../assets/icon_finance@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 12px">金融</div>
                </van-grid-item>

                <van-grid-item @click="toliost(3)">
                  <img src="../../assets/icon_car@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 12px">贸易物流</div>
                </van-grid-item>
                <van-grid-item @click="toliost(4)">
                  <img src="../../assets/icon_educate@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 12px">教育传媒</div>
                </van-grid-item>
                <van-grid-item @click="toliost(5)">
                  <img src="../../assets/icon_media@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 12px">服务业</div>
                </van-grid-item>
                <van-grid-item @click="toliost(6)">
                  <img
                    src="../../assets/icon_Medical_treatment@2x.png"
                    alt=""
                  />
                  <div style="padding-top: 12px; font-size: 12px">市场销售</div>
                </van-grid-item>
                <van-grid-item @click="toliost(7)">
                  <img src="../../assets/icon_traffic@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 12px">人事财务</div>
                </van-grid-item>
                <van-grid-item @click="toliost(8)">
                  <img src="../../assets/icon_estate@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 12px">房地产</div>
                </van-grid-item>
              </van-grid>
            </van-swipe-item>
            <!-- <van-swipe-item class="gridlist">
              <van-grid style="padding-bottom: 20px" :border="false">
                <van-grid-item @click="toliost(null)">
                  <img src="../../assets/icon_internet@2x.png" alt="" />
                  <div style="padding-top: 12px; font-size: 14px">其他</div>
                </van-grid-item>
  
              </van-grid>
            </van-swipe-item> -->
          </van-swipe>
        </div>

        <!-- 热门公司 -->
        <div class="box" style="margin-top: 10px" v-if="selected == 2">
          <div
            style="
              padding: 10px 0px;
              position: relative;
              font-size: 18px;
              width: 100%;
            "
          >
            <!-- <span class="dot"></span> -->
            <span style="padding-left: 20px; font-weight: bold">热门公司</span>
            <span class="title_right" @click="toliost(null)">
              更多
              <van-icon name="arrow" class="icon_right" />
            </span>
          </div>

          <van-grid
            class="gongsi"
            style="padding-bottom: 20px"
            :border="false"
            :gutter="10"
            :column-num="2"
          >
            <van-grid-item class="blue" v-if="enterprise[0]">
              <div style="font-size: 14px">{{ enterprise[0].Name }}</div>
              <div class="gongsiMs">
                <div
                  class="van-ellipsis"
                  style="width: 70%; display: inline-block"
                >
                  {{ enterprise[0].ETypeName }}
                </div>
                <div>{{ enterprise[0].CoScale }}</div>
              </div>
            </van-grid-item>
            <van-grid-item class="green" v-if="enterprise[1]">
              <div style="font-size: 14px">{{ enterprise[1].Name }}</div>
              <div class="gongsiMs">
                <div
                  class="van-ellipsis"
                  style="width: 70%; display: inline-block"
                >
                  {{ enterprise[1].ETypeName }}
                </div>
                <div style="width: 50px">{{ enterprise[1].CoScale }}</div>
              </div>
            </van-grid-item>
            <van-grid-item class="red" v-if="enterprise[2]">
              <div style="font-size: 14px">{{ enterprise[2].Name }}</div>
              <div class="gongsiMs">
                <div
                  class="van-ellipsis"
                  style="width: 70%; display: inline-block"
                >
                  {{ enterprise[2].ETypeName }}
                </div>
                <div>{{ enterprise[2].CoScale }}</div>
              </div>
            </van-grid-item>
            <van-grid-item class="orange" v-if="enterprise[3]">
              <div style="font-size: 14px">{{ enterprise[3].Name }}</div>
              <div class="gongsiMs">
                <div
                  class="van-ellipsis"
                  style="width: 70%; display: inline-block"
                >
                  {{ enterprise[3].ETypeName }}
                </div>
                <div>{{ enterprise[3].CoScale }}</div>
              </div>
            </van-grid-item>
          </van-grid>

          <van-empty description="暂无热门公司" v-if="enterprise.length == 0" />
        </div>
      </div>
    </div>
    <!-- <van-tabbar v-model="active">
      <van-tabbar-item icon="manager-o" to="/list/firmlogin/"
        >企业端登录</van-tabbar-item
      >
      <van-tabbar-item icon="wap-home-o" to="/">首页</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/list/recruitment/"
        >求职者登录</van-tabbar-item
      >
    </van-tabbar> -->
  </div>
</template>
<script>
import config from "@/config";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
import wx from "weixin-js-sdk";
import { getToken, getaccToken, getstaffToken } from "@/utils/auth";
import { WeGetJobPage } from "@/api/ResumeJS";
import { GetAbilityList, getEnterprise } from "@/api/REplat";
export default {
  data() {
    return {
      itemmark: "", //职位详情
      listdata: {
        accToken: getToken(), //token
        title: "", //名称
        abiCode: "", //职业编码
        abiName: "", //职业名称
        workAddr: "", //地址
        eName: "", //企业
        limit: 10,
        page: 1,
      },
      conterlist: [
        { value: 1, Name: "互联网", url: "../../assets/icon_internet@2x.png" },
        { value: 2, Name: "金融", url: "../../assets/icon_finance@2x.png" },
        { value: 3, Name: "房地产", url: "../../assets/icon_estate@2x.png" },
        { value: 4, Name: "汽车", url: "../../assets/icon_car@2x.png" },
        { value: 5, Name: "教育培训", url: "../../assets/icon_educate@2x.png" },
        { value: 6, Name: "广告传媒", url: "../../assets/icon_media@2x.png" },
        {
          value: 7,
          Name: "医疗制药",
          url: "../../assets/icon_Medical_treatment@2x.png",
        },
        { value: 8, Name: "交通运输", url: "../../assets/icon_traffic@2x.png" },
      ],
      active: 0,
      list: [], //列表
      count: 0,
      zhiye: [],
      NativeCantonCodedata: [],
      search: false, //搜索框显示
      abiName: false,
      hidden: false,
      routers: {},
      enterprise: [],
      selected: 1,
    };
  },
  created() {
    // this.GetJobPage()
    // this.zidianlist();
    this.getEnterprise();
    console.log(getToken());
  },
  methods: {
    tapClick(val) {
      this.selected = val;
      if (val == 2) {
        this.getEnterprise();
      }
    },
    // 获取公司列表
    getEnterprise() {
      getEnterprise({ isAgency: 0, limit: 4 }).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          this.enterprise = res.data.data;
        }
      });
    },
    firmlogin() {
      if (getaccToken() == undefined) {
        this.$router.push({
          path: "/list/firmlogin/",
        });
      } else {
        this.$router.push({
          path: "/list/company",
        });
      }
    },
    recruitment() {
      if (getToken() == undefined) {
        this.$router.push({
          path: "/list/recruitment/",
        });
      } else {
        this.$router.push({
          path: "/list/jobhunter",
        });
      }
    },
    // 员工登录
    staffLogin() {
      if (getstaffToken() == undefined) {
        this.$router.push({
          path: "/list/staffLogin/",
        });
      } else {
        // 跳转到 另一个项目
        window.location.href =
          "https://workflow.anluoyun.cn/sign?userId=" +
          JSON.parse(getstaffToken()).userId +
          "&companyName=" +
          JSON.parse(getstaffToken()).companyName +
          "&companyId=" +
          JSON.parse(getstaffToken()).companyId +
          "&platformId=" +
          config.platformId1 +
          "&nickName=" +
          JSON.parse(getstaffToken()).userName;
      }
    },

    toliost(e) {
      var canshu = {
        title: this.listdata.title,
        eName: this.listdata.eName,
        workAddr: this.listdata.workAddr,
      };
      if (e == null) {
        canshu.abiCode = e;
      } else {
        canshu.abiCode = "0" + e;
      }
      this.routers = JSON.stringify(canshu);
      this.$router.push({
        path: "/list/positionlist/" + this.routers,
      });
    },
    pageclick(e) {
      this.listdata.page = e;
      this.GetJobPage();
    },
    onSearch() {
      this.listdata.page = 1;
      this.GetJobPage();
    },
    //小程序跳转到小程序
    gotominiProgram(name) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/openminip?name=" + name,
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    serachGo() {
      this.GetJobPage();
      this.search = false;
    },
    serachReset() {
      this.listdata = {
        accToken: getToken(), //token
        title: "", //名称
        abiCode: "", //职业编码
        abiName: "", //职业名称
        workAddr: "", //地址
        eName: "", //企业
      };
      this.GetJobPage();
      this.search = false;
    },
    // 获取职业列表
    GetJobPage() {
      WeGetJobPage(this.listdata).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          if (res.data.data.length == 0) {
            this.hidden = true;
            this.list = [];
          } else {
            this.hidden = false;
            this.list = res.data.data;
            this.count = res.data.count;
          }
        } else {
          this.hidden = true;
          Toast.fail("获取失败!" + res.data.msg);
        }
      });
    },
    // 跳转职位详情
    todetail(row) {
      this.itemmark = JSON.stringify(row);
      this.$router.push({
        name: "detail",
        query: { JId: this.itemmark },
      });
    },
    // 字典
    zidianlist: function () {
      GetAbilityList().then((res) => {
        this.zhiye = res.data.data;
      });
    },
    // 行业选中
    onabiName: function (val) {
      console.log(val);
      if (val.selectedOptions.length == 1) {
        this.listdata.abiCode = val.selectedOptions[0].Coding;
        this.listdata.abiName = val.selectedOptions[0].Name;
      } else {
        this.listdata.abiCode = val.selectedOptions[1].Coding;
        this.listdata.abiName = val.selectedOptions[1].Name;
      }
      this.abiName = false;
    },
  },
};
</script>
<style>
.recruitment {
  background: #eceff0;
  min-height: 100%;
}
.van-hairline--bottom:after {
  border-bottom-width: 0px;
}
.recruitment .van-nav-bar__title {
  color: #fff;
}
.recruitment .van-nav-bar__content {
  background: #0188fb;
}
.postlist {
  margin: 5px 0px;
  background: #fff;
}
.postlist .listtitle {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 5px;
  font-size: 700;
  color: #000;
}
.postlist .listtwo {
  padding: 0px 10px;
  font-size: 12px;
}
.postlist .listtwo span {
  padding: 6px;
  background: rgb(238, 237, 237);
  margin-right: 8px;
  color: #666;
}
.postlist .listthree {
  display: flex;
  flex-wrap: nowrap;
  padding: 10px;
  font-size: 14px;
}
.postlist .listthree span {
  margin-right: 30px;
  color: #666;
}
.postlist .listfore {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 0px 0px 15px 10px;
  font-size: 13px;
}
.postlist .listfore span {
  margin-right: 15px;
  color: #a3a7a8;
}
.van-search__action {
  margin-right: 10px !important;
  color: #fff;
}
.van-search__action:active {
  background: #0188fb;
}
.nameResume {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background: #0188fb;
  padding: 8px;
  width: 50px;
  height: 50px;
  font-size: 12px;
  line-height: 50px;
  border-radius: 15px;
  color: #fff;
}
.nameResumes {
  position: fixed;
  right: 100px;
  bottom: 20px;
  background: #0188fb;
  text-align: center;
  padding: 8px;
  width: 50px;
  height: 50px;
  font-size: 12px;
  line-height: 50px;
  border-radius: 15px;
  color: #fff;
}

.gridlist img {
  width: 60%;
}
.box {
  width: 95%;
  margin: 10px 2.5%;
  background: #fff;
  border-radius: 8px;
}
.box .van-notice-bar {
  border-radius: 8px;
  background: #fff;
}
.dot {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 4px;
  height: 18px;
  border-radius: 3px;
  background: #ff9d30;
  margin: 0px 10px 0px 10px;
}
.title_right {
  color: #7d7d7d;
  position: absolute;
  right: 15px;
  font-size: 14px;
}
.icon_right {
  position: relative;
  right: 0px;
  top: 2px;
}
.loginbox div {
  position: relative;
  display: flex;
  width: 100%;
  background: #5d77ec;
  height: 81px;
  color: #000;
  border-radius: 8px;
  color: white;
}
.loginbox_A {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  margin-top: 3px;
}

.item {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
}
.blue .van-grid-item__content {
  width: 100%;
  color: #fff;
  /* background:#4a8bfe; */
  background: url("../../assets/img_company_bj1@2x.png") no-repeat center center;
}
.green .van-grid-item__content {
  width: 100%;
  color: #fff;
  background: url("../../assets/img_company_bj2@2x.png") no-repeat center center;
}
.red .van-grid-item__content {
  width: 100%;
  color: #fff;
  background: url("../../assets/img_company_bj3@2x.png") no-repeat center center;
}
.orange .van-grid-item__content {
  width: 100%;
  color: #fff;
  background: url("../../assets/img_company_bj4@2x.png") no-repeat center center;
}
.gongsi .van-grid-item__content--center {
  -webkit-align-items: end;
  align-items: end;
}
.gongsi .van-grid-item__content {
  padding: 4px 8px;
  background-size: 100%;
  border-radius: 8px;
}
</style>
<style scoped>
.van-grid-item {
  width: 50%;
}
.gongsiMs {
  font-size: 12px;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  /* flex-wrap: wrap; */
  width: 100%;
}
.search {
  display: flex;
  align-items: center;
  position: absolute;
  background: #ffffff2f;
  left: 5%;
  top: 10px;
  width: 85%;
  height: 45px;
  padding-left: 15px;
  font-size: 14px;
  border-radius: 25px;
  color: #ffffff;
}
.topSearch {
  position: absolute;
  width: 80%;
  background: #0084f800;
  height: 55px;
  z-index: 9;
  top: 50px;
}
.topBox {
  border-radius: 8px 8px 0px 0px;
  background-color: #5670e5;
  position: absolute;
  width: 100%;
  top: 293px;
  color: white;
  line-height: 40px;
  display: flex;
}
.topBoxLeft {
  border-radius: 8px 8px 0px 0px;
  background-color: white;
  width: 100px;
  color: black;
  font-weight: bold;
  text-align: center;
}
.topBoxLeft::after {
  content: "";
  position: absolute;
  top: 0;
  left: 78px;
  height: 100%;
  width: 20px; /* 边框的宽度 */
  border-radius: 8px 8px 0px 0px;
  background-color: #fff; /* 边框颜色 */
  transform: skewX(22deg); /* 倾斜角度 */
  transform-origin: top right; /* 倾斜基准点 */
}
.topBoxRight {
  margin-left: 0px;
  border-radius: 8px 8px 0px 0px;
  background-color: white;
  width: 100px;
  color: black;
  font-weight: bold;
  text-align: center;
}
.topBoxRight::after {
  content: "";
  position: absolute;
  top: 0;
  left: 178px;
  height: 100%;
  width: 20px; /* 边框的宽度 */
  border-radius: 8px 8px 0px 0px;
  background-color: #fff; /* 边框颜色 */
  transform: skewX(22deg); /* 倾斜角度 */
  transform-origin: top right; /* 倾斜基准点 */
}
</style>
